export const rangoFechas = {
  desde: "De",
  hasta: "Até",
  etiqueta: "Datas",
  quitar: "Limpar datas",
  titulo: "Escolher datas",
  elegirInicio: "Toca no primeiro dia",
  elegirFin: "Agora toca no último dia",
  dias: "dia | dias",
  anterior: "Mês anterior",
  siguiente: "Mês seguinte",
  cancelar: "Cancelar",
  aplicar: "Aplicar",
};
